/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SemcoStereotypes {
    Disruption = '0',
    DefaultAddress = 1,
    ServiceProvider = 2,
    Customer = 3,
    Branch = 4,
    Production = 5,
    Employee = 6,
    Technician = 7,
    Material = 8,
    Apparatus = 9,
    Group = 10,
    GroupForLocations = 11,
    District = 12,
    Assignment = 13,
    Contract = 14,
    ArticleStandard = 15,
    MissionReportStandard = 16,
    InspectionReportStandard = 17,
    ControlTag = 18,
}
